import { ToolBox } from '../../toolbox/ToolBox';
import KeyEvent from '../android/KeyEvent';
import SvgImage from '../../ui/SvgImage';
import { KeyCodeControlMessage } from '../../controlMessage/KeyCodeControlMessage';
import { ToolBoxButton } from '../../toolbox/ToolBoxButton';
import { ToolBoxElement } from '../../toolbox/ToolBoxElement';
import { ToolBoxCheckbox } from '../../toolbox/ToolBoxCheckbox';
import { BasePlayer } from '../../player/BasePlayer';
import { BroadcastService } from '../../interactionHandler/BroadcastService';
import request from '@/utils'
import store from '../../../store'
import { eventBus } from '@/utils/eventBus';
import { ElMessageBox } from 'element-plus';
import { StreamClientLike } from '../../streaming/StreamClientLike';
const BUTTONS = [
	{
		title: '电源',
		code: KeyEvent.KEYCODE_POWER,
		icon: SvgImage.Icon.POWER,
	},
	{
		title: '声音增大',
		code: KeyEvent.KEYCODE_VOLUME_UP,
		icon: SvgImage.Icon.VOLUME_UP,
	},
	{
		title: '声音减小',
		code: KeyEvent.KEYCODE_VOLUME_DOWN,
		icon: SvgImage.Icon.VOLUME_DOWN,
	},
	{
		title: '回退',
		code: KeyEvent.KEYCODE_BACK,
		icon: SvgImage.Icon.BACK,
	},
	{
		title: '主界面',
		code: KeyEvent.KEYCODE_HOME,
		icon: SvgImage.Icon.HOME,
	},
	{
		title: '浏览页',
		code: KeyEvent.KEYCODE_APP_SWITCH,
		icon: SvgImage.Icon.OVERVIEW,
	}
];

export class GoogToolBox extends ToolBox {
	protected constructor(list : ToolBoxElement<any>[]) {
		super(list);
	}

	/**
	 * 设置右键菜单
	 */
	private static setupContextMenu(udid: string, client: StreamClientLike) {
		const handleContextMenu = (e: any) => {
			const { event, udid: eventUdid } = e.detail;
			if (eventUdid === udid) {
				eventBus.emit('show-phone-context-menu', { event, phoneId: client.phoneId, client });
			}
		};
		window.removeEventListener('phone-contextmenu', handleContextMenu);
		window.addEventListener('phone-contextmenu', handleContextMenu);
	}

	/**
	 * 向其他云手机广播消息
	 */
	private static async broadcastButtonEvent(
		client : StreamClientLike,
		sourcePhoneId : string,
		event : KeyCodeControlMessage
	) {
		// 只在主控设备且同步开启时广播
		if (!client.is_master_cloud) {
			return;
		}

		const broadcastData = {
			type: 'button_key_event',
			action: event.action,
			keycode: event.keycode,
			metaState: event.metaState || 0,
			timestamp: Date.now(),
			repeat: event.repeat || 0,
			sourcePhoneId
		};

		if ((window as any).electronAPI && typeof (window as any).electronAPI.broadcastControl === 'function') {
			try {
				(window as any).electronAPI.broadcastControl({
					sourcePhoneId,
					groupId: 'default',
					message: broadcastData
				});
			} catch (error) {
				console.error('Broadcast failed:', error);
			}
			return;
		}
		// 网页端：走进程内 EventBus，与 FeaturedInteractionHandler 的触摸/滚动广播同机制
		try {
			const { BroadcastBus } = await import('../../interactionHandler/BroadcastBus');
			BroadcastBus.getInstance().emit({
				sourcePhoneId,
				groupId: 'default',
				message: broadcastData,
				timestamp: Date.now(),
			});
			console.info('[GoogToolBox][web-emit] button', sourcePhoneId, 'keycode=', event.keycode, 'action=', event.action);
			try { (window as any).__onGroupMasterActivity?.(); } catch (_e) {}
		} catch (error) {
			console.error('[GoogToolBox] web broadcast failed:', error);
		}
	}

	public static createToolBox(
		udid : string,
		player : BasePlayer,
		client : StreamClientLike,
		moreBox ?: HTMLElement,
		options ?: { hideKeyboard ?: boolean },
	) : GoogToolBox {
		const playerName = player.getName();
		const list = BUTTONS.slice();

		// 设置右键菜单事件监听
		GoogToolBox.setupContextMenu(udid, client);

		const handler = <K extends keyof HTMLElementEventMap, T extends HTMLElement>(
			type : K,
			element : ToolBoxElement<T>,
		) => {
			if (!element.optional?.code) {
				return;
			}
			const { code } = element.optional;
			const action = type === 'mousedown' ? KeyEvent.ACTION_DOWN : KeyEvent.ACTION_UP;
			const event = new KeyCodeControlMessage(action, code, 0, 0);
			// 发送到当前设备
			client.sendMessage(event);
			// 广播到其他云手机
			this.broadcastButtonEvent(client, udid, event);
		};

		const elements : ToolBoxElement<any>[] = list.map((item) => {
			const button = new ToolBoxButton(item.title, item.icon, {
				code: item.code,
			});
			button.addEventListener('mousedown', handler);
			button.addEventListener('mouseup', handler);
			return button;
		});

		if (player.supportsScreenshot) {
			const screenshot = new ToolBoxButton('屏幕截图', SvgImage.Icon.CAMERA);
			screenshot.addEventListener('click', () => {
				player.createScreenshot(client.getDeviceName());
			});
			elements.push(screenshot);
		}

		if (!options?.hideKeyboard) {
		const keyboard = new ToolBoxCheckbox(
			'本地键盘',
			SvgImage.Icon.KEYBOARD,
			`capture_keyboard_${udid}_${playerName}`,
		);
		keyboard.addEventListener('click', (_, el) => {
			const element = el.getElement();
			client.setHandleKeyboardEvents(element.checked);

			// 把云手机本地键盘还是云手机自带键盘开关群体设置
			if (client.is_master_cloud && store.state.is_sync) {
				BroadcastService.getInstance().change_keyboard_ToAll(
					client,
					element.checked,
					true
				);
			}
		});
		elements.push(keyboard);
		}
		//重启云机
		const restart_phone = new ToolBoxButton('重启云机', SvgImage.Icon.RESTARTPHONE);
		restart_phone.addEventListener('click', () => {
			store.commit('change_phone_state', true);
			const requestData = { instance_id: client.phoneId };
			// 先发送重启请求
			const response = request.post('/containers/restart', requestData);
			response.then(() => {
				// 重启请求成功后，开始轮询状态
				const pollingInterval = setInterval(() => {
					// 每次间隔1秒后查询状态
					request.post('/containers/info', requestData).then((res2) => {
						if (res2.data.data?.instances?.rtc_status == 1) {
							// 状态满足条件，清除轮询
							clearInterval(pollingInterval);
							// 6秒后更新状态
							setTimeout(() => {
								eventBus.emit('initPhone', res2.data.data, 1000, false);
								store.commit('change_phone_state', false);
							}, 8000);
						}
					}).catch((error) => {
						console.error('查询状态失败:', error);
					});
				}, 1000); // 每隔1秒轮询一次
			}).catch((error) => {
				console.error('重启请求失败:', error);
				store.commit('change_phone_state', false);
			});
		});
		// 隐藏：重启/重置/一键新机/更换机型（已在"云机详细信息"侧边栏里提供）
		const HIDE_PHONE_ACTIONS = true;
		if (!HIDE_PHONE_ACTIONS) {
			elements.push(restart_phone);
		}
		//重置云机
		const reset_phone = new ToolBoxButton('重置云机', SvgImage.Icon.RESETPHONE);
		reset_phone.addEventListener('click', () => {
			ElMessageBox.confirm(
				'重置云机将清空云机内数据，是否确认重置?',
				'警告',
				{
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
				}
			)
				.then(() => {
					store.commit('change_phone_state', true);
					const requestData = { instance_id: client.phoneId };
					const response = request.post('/containers/batch_reset', requestData);
					response.then(() => {
						// 重启请求成功后，开始轮询状态
						const pollingInterval = setInterval(() => {
							// 每次间隔1秒后查询状态
							request.post('/containers/info', requestData).then((res2) => {
								if (res2.data.data?.instances?.rtc_status == 1) {
									// 状态满足条件，清除轮询
									clearInterval(pollingInterval);
									// 6秒后更新状态
									setTimeout(() => {
										eventBus.emit('initPhone', res2.data.data, 1000, false);
										store.commit('change_phone_state', false);
									}, 8000);
								}
							}).catch((error) => {
								console.error('查询状态失败:', error);
							});
						}, 1000); // 每隔1秒轮询一次
					}).catch((error) => {
						console.error('重启请求失败:', error);
						store.commit('change_phone_state', false);
					});
				})
				.catch(() => { })
		});
		if (!HIDE_PHONE_ACTIONS) elements.push(reset_phone);
		//一键新机
		const one_key_phone = new ToolBoxButton('一键新机', SvgImage.Icon.ONEKEYPHONE);
		one_key_phone.addEventListener('click', () => {
			ElMessageBox.confirm(
				'一键新机将清空云机内数据，是否确认重置?',
				'警告',
				{
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
				}
			)
				.then(() => {
					store.commit('change_phone_state', true);
					const requestData = { instance_id: client.phoneId };
					const response = request.post('/containers/easy_recreate', requestData);
					response.then(() => {
						// 重启请求成功后，开始轮询状态
						const pollingInterval = setInterval(() => {
							// 每次间隔1秒后查询状态
							request.post('/containers/info', requestData).then((res2) => {
								if (res2.data.data?.instances?.rtc_status == 1) {
									// 状态满足条件，清除轮询
									clearInterval(pollingInterval);
									// 6秒后更新状态
									setTimeout(() => {
										eventBus.emit('initPhone', res2.data.data, 1000, false);
										store.commit('change_phone_state', false);
									}, 8000);
								}
							}).catch((error) => {
								console.error('查询状态失败:', error);
							});
						}, 1000); // 每隔1秒轮询一次
					}).catch((error) => {
						console.error('重启请求失败:', error);
						store.commit('change_phone_state', false);
					});
				})
				.catch(() => { })
		});
		if (!HIDE_PHONE_ACTIONS) elements.push(one_key_phone);
		const change_type_phone = new ToolBoxButton('更换机型', SvgImage.Icon.CHANGETYPEPHONE);
		change_type_phone.addEventListener('click', () => {
			eventBus.emit('openChangePhoneTypeDialog');
		});
		if (!HIDE_PHONE_ACTIONS) elements.push(change_type_phone);
		if (moreBox) {
			const displayId = player.getVideoSettings().displayId;
			const id = `show_more_${udid}_${playerName}_${displayId}`;
			const more = new ToolBoxCheckbox('More', SvgImage.Icon.MORE, id);
			more.addEventListener('click', (_, el) => {
				const element = el.getElement();
				moreBox.style.display = element.checked ? 'block' : 'none';
			});
			elements.unshift(more);
		}

		return new GoogToolBox(elements);
	}
}
